'use client';

import {
  TrackedButton,
  type TrackedButtonProps,
} from '@/components/button/tracked-button';
import { cn } from '@lib/utils';

/** NEO 섹션 CTA 버튼 공통 베이스 — pill 모양 + 폰트 + 포커스/호버 인터랙션 */
export const CTA_PILL_CLASS =
  'rounded-[53px] md:px-10 py-[15px] text-base font-semibold leading-6 tracking-[-0.18px] text-white transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2';

/**
 * NEO 섹션 CTA 버튼. 클릭 시 GA click_button 이벤트를 전송한다(TrackedButton 기반).
 * label = GA 추적용 라벨, position = 추적 위치, children = 화면에 노출되는 텍스트.
 */
export function CtaButton({ className, ...rest }: TrackedButtonProps) {
  return (
    <TrackedButton
      type="button"
      className={cn(
        'transition-opacity hover:opacity-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2',
        className,
      )}
      {...rest}
    />
  );
}
